// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';

export const GlobalFooter = (el) => {
  const ui = {
    el,
    body: select('body', document),
    pageshell: select('.pageshell'),
    fullHeightMarquee: select('.marquee--full-height .marquee__major'),
  };

  const setPadding = (padding) => {
    let pageWidthThreshold = 834;
    let pageWidth = ui.body.clientWidth;
    
    if (ui.pageshell) {
      if (pageWidth > pageWidthThreshold) {
        ui.pageshell.style.paddingBottom = padding;
      } else {
        ui.pageshell.style.paddingBottom = 0;
      }
    }
  }

  const getFooterHeight = () => {
    let footerHeight = (el.clientHeight - 1) + 'px';
    setPadding(footerHeight);
  }

  const addEvents = () => {
    getFooterHeight();

    window.addEventListener("resize", function(){ 
      getFooterHeight();
    }, false );
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default GlobalFooter;
